import { Pipe, PipeTransform } from '@angular/core';
/**
 * Sort Array by timestamp
 *
 * @export SortTimeStampPipe
 */
@Pipe({
  name: 'sortTimeStamp'
})

export class SortTimeStampPipe implements PipeTransform {

  /**
   * Takes an Array of objects with the property "timestamp" and sort it by said property
   *
   * @param value Input array to be sorted
   * @param dir Boolean to determine if to sort in ascending or descending order
   * @returns Sorted Array of objects
   */
  transform(value: Array<any>, dir?: boolean): any {
    if (value) {
      if (!dir) {
        return value.sort(
          (a: any, b: any) => {
            if (a.timestamp > b.timestamp) {
              return -1;
            } else if (a.timestamp < b.timestamp) {
              return 1;
            } else {
              return 0;
            }
          }
        );
      } else {
        return value.sort(
          (a: any, b: any) => {
            if (a.timestamp < b.timestamp) {
              return -1;
            } else if (a.timestamp > b.timestamp) {
              return 1;
            } else {
              return 0;
            }
          }
        );
      }
    }
  }

}
